import {
	type InitFlowPageProps,
	NCOnboardingRoutesEnum,
	useNCWOnboardingRoutes
} from '@capsicum/features/nc-onboarding/shared';
import { match } from 'ts-pattern';

import { CongratulationsScreen } from '../../../ui';
import { NCRegistration } from '../../registration';

export const NCWNewUserOnboardingFlow = ({ done }: InitFlowPageProps) => {
	const { currentRoute, goToPage, onDone } = useNCWOnboardingRoutes({ done, isNewUser: true });

	return match(currentRoute)
		.with(NCOnboardingRoutesEnum.REGISTRATION, () => (
			<NCRegistration
				variant="INIT_FLOW"
				waitForWalletStatus={false}
				onSuccess={() => goToPage(NCOnboardingRoutesEnum.CONGRATULATIONS)}
			/>
		))
		.with(NCOnboardingRoutesEnum.CONGRATULATIONS, () => <CongratulationsScreen isNewUser onDone={onDone} />)
		.otherwise(() => (
			<NCRegistration
				variant="INIT_FLOW"
				waitForWalletStatus={false}
				onSuccess={() => goToPage(NCOnboardingRoutesEnum.CONGRATULATIONS)}
			/>
		));
};
